import { useEffect, useState } from "react";
import axios from "axios";

const DashboardPage = () => {
  const [verraNewsFeedItems, setVerraNewsFeedItems] = useState([]);

  useEffect(() => {
    // fetch data from API
    axios
      .get("https://rss.app/feeds/v1.1/Qtr3AFdJd4OHHl1d.json")
      .then((response) => {
        setVerraNewsFeedItems(response?.data?.items.slice(0, 10));
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const convertTime = (time: string) => {
    // Original timestamp in UTC
    const originalTimestamp: Date = new Date(time);

    // Convert to IST (Indian Standard Time, UTC+5:30)
    const istTimestamp: Date = new Date(originalTimestamp);
    istTimestamp.setHours(istTimestamp.getHours() + 5); // Add 5 hours to UTC
    istTimestamp.setMinutes(istTimestamp.getMinutes() + 30); // Add 30 minutes to UTC

    // Format the IST timestamp
    const options: Intl.DateTimeFormatOptions = { day: "numeric", month: "short", year: "numeric" };
    const formattedTimestamp: string = istTimestamp.toLocaleDateString("en-IN", options);

    return formattedTimestamp;
  };

  return (
    <section className="p-4">
      <div className="grid grid-cols-4 gap-4">
        {/* projects div */}
        <div className="rounded-md bg-white p-4 shadow-sm">Projects</div>

        {/* clients div */}
        <div className="rounded-md bg-white p-4 shadow-sm">Clients</div>

        {/* todo div */}
        <div className="rounded-md bg-white p-4 shadow-sm">
          <h1 className="font-semibold">To Do</h1>
          <div className="grid grid-cols-2 gap-2 py-2">
            <div>
              <h1 className="font-semibold text-gray-800">20</h1>
              <p className="text-sm text-gray-600">Document Review</p>
            </div>

            <div>
              <h1 className="font-semibold text-gray-800">30</h1>
              <p className="text-sm text-gray-600">Lorem</p>
            </div>
            <div>
              <h1 className="font-semibold text-gray-800">40</h1>
              <p className="text-sm text-gray-600">Lorem</p>
            </div>
            <div>
              <h1 className="font-semibold text-gray-800">20</h1>
              <p className="text-sm text-gray-600">Submit Document</p>
            </div>
          </div>
        </div>

        {/* Registry updates div */}
        <div className="rounded-md bg-white p-4 shadow-sm">
          <h1 className="font-semibold">Registry Updates</h1>

          {/* registry updates div */}
          <div className="mt-3 h-44 space-y-2 overflow-y-auto">
            {verraNewsFeedItems.map((item: any, index) => {
              return (
                <div key={index}>
                  <div className="flex items-start gap-2">
                    <div className="basis-1/5 rounded-sm">
                      <img src={item.image} alt="new feed item image" className="rounded-sm" />
                    </div>
                    <div className="basis-4/5">
                      <h1 className="font-semibold">{item.title}</h1>
                      <p className="text-sm text-gray-400">{convertTime(item.date_published)}</p>
                    </div>
                  </div>
                  <div className="my-2 h-[0.2px] w-full bg-gray-200"></div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Carbon Emmison Reduction chart */}
        <div className="col-span-2 rounded-md bg-white p-4 shadow-sm">Carbon Emmison Reduction</div>

        {/* Projects By Country map */}
        <div className="col-span-2 rounded-md bg-white p-4 shadow-sm">Projects By Country</div>
      </div>

      {/* projects details table */}
      <div className="mt-4 rounded-md bg-white p-4 shadow-sm">Project data table goes here</div>
    </section>
  );
};

export default DashboardPage;
